import { Link } from "react-router-dom";
import { FadeUp, SectionEyebrow, SectionTitle } from "./_shared";
import { UpdateCard } from "./_partials/UpdateCard";
import { FIELD_UPDATES, INSTAGRAM_PROFILE } from "@/data/updates";

export default function UpdatesSection() {
  return (
    <section id="updates" data-testid="updates-section" className="py-24 md:py-32 bg-card border-y border-border">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <FadeUp className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-3xl">
            <SectionEyebrow>Field Updates</SectionEyebrow>
            <SectionTitle className="mt-4 text-[clamp(1.9rem,4.5vw,3.25rem)]">
              Stages, Interviews &amp; <em className="not-italic text-accent">Education</em>
            </SectionTitle>
          </div>
          <a href={INSTAGRAM_PROFILE.url} target="_blank" rel="noopener noreferrer" data-testid="updates-instagram-profile" className="font-mono text-xs uppercase tracking-[0.14em] text-primary hover:text-accent transition-colors">
            {INSTAGRAM_PROFILE.handle} →
          </a>
        </FadeUp>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FIELD_UPDATES.map((update, index) => (
            <FadeUp key={update.id} delay={index * 0.08}>
              <UpdateCard update={update} />
            </FadeUp>
          ))}
        </div>

        <FadeUp className="mt-9 text-center">
          <Link to="/updates" data-testid="updates-view-all" className="iw-btn-ghost inline-flex items-center gap-2 px-8 py-4 text-xs">
            View Updates &amp; Education <span aria-hidden>→</span>
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}